<template>
  <section id="profile-show">
    <v-container>
      <v-row justify="center">
        <v-col cols="12" lg="7">
          <v-row>
            <v-col cols="12">
              <v-card outlined class="mb-3">
                <v-list>
                  <v-list-item>
                    <v-list-item-avatar size="80" tile>
                      <v-avatar
                        size="80"
                        :color="
                          $vuetify.theme.dark
                            ? 'blue-grey darken-4'
                            : 'blue-grey lighten-5'
                        "
                      >
                        <v-img
                          v-if="User.url_image"
                          :src="User.url_image"
                          alt="Avatar del usuario"
                        ></v-img>
                        <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                      </v-avatar>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        class="mb-2 text-uppercase primary--text"
                        >{{ User.name }}</v-list-item-title
                      >
                      <v-list-item-subtitle>
                        {{ userRol() }}
                      </v-list-item-subtitle>
                    </v-list-item-content>

                    <v-list-item-actions v-if="!isMobile">
                      <v-btn
                        class="ma-2 shadow-4 rounded-small"
                        :loading="loading"
                        :disabled="loading"
                        color="success"
                        @click="openUploadAvatarDialog"
                      >
                        Cambiar foto
                      </v-btn>
                    </v-list-item-actions>
                  </v-list-item>
                </v-list>
                <v-card-actions v-if="isMobile">
                  <v-container class="pt-0">
                    <v-btn
                      block
                      class="shadow-4 rounded-small"
                      :loading="loading"
                      :disabled="loading"
                      color="success"
                      @click="openUploadAvatarDialog"
                    >
                      Cambiar foto
                    </v-btn>
                  </v-container>
                </v-card-actions>
              </v-card>

              <v-card outlined>
                <v-tabs color="primary">
                  <v-tab>Datos</v-tab>
                  <v-tab>Contraseña</v-tab>

                  <v-tab-item>
                    <v-card-text>
                      <ValidationObserver ref="obs" v-slot="{ passes }">
                        <v-row align="end" justify="end">
                          <v-col cols="12" class="py-0">
                            <p
                              class="subtitle-1 font-weight-bold secondary--text"
                            >
                              Datos personales
                            </p>
                            <ValidationProvider
                              name="nombre y apellido"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                filled
                                rounded
                                class="rounded-small"
                                required
                                label="Nombre y apellido"
                                v-model.trim="userdata.name"
                                :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" class="py-0">
                            <ValidationProvider
                              name="correo"
                              rules="email|required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                filled
                                rounded
                                class="rounded-small"
                                required
                                label="Correo"
                                v-model="userdata.email"
                                :error-messages="errors"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-btn
                              :disabled="oldDataComparison"
                              large
                              block
                              class="rounded-small"
                              color="success shadow-4"
                              @click="passes(UpdateData)"
                              >Actualizar</v-btn
                            >
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-card-text>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card-text>
                      <ValidationObserver
                        ref="passwordForm"
                        v-slot="{ passes }"
                      >
                        <v-row>
                          <v-col cols="12" class="py-0">
                            <p
                              class="subtitle-1 font-weight-bold secondary--text"
                            >
                              Contraseña actual
                            </p>
                            <ValidationProvider
                              name="contraseña actual"
                              rules="required"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                filled
                                rounded
                                class="rounded-small"
                                required
                                label="Contraseña actual"
                                :append-icon="
                                  showOldPassword
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                :type="showOldPassword ? 'text' : 'password'"
                                v-model="old_password"
                                :error-messages="errors"
                                @click:append="
                                  showOldPassword = !showOldPassword
                                "
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>
                        </v-row>

                        <v-row align="end" justify="end">
                          <v-col cols="12" class="py-0">
                            <p
                              class="subtitle-1 font-weight-bold secondary--text"
                            >
                              Nueva contraseña
                            </p>
                            <ValidationProvider
                              name="nueva contraseña"
                              rules="confirmed:confirmation|required|min:8"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                filled
                                rounded
                                class="rounded-small"
                                required
                                label="Contraseña"
                                :append-icon="
                                  showPassword
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                :type="showPassword ? 'text' : 'password'"
                                v-model="password"
                                :error-messages="errors"
                                @click:append="showPassword = !showPassword"
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" class="py-0">
                            <ValidationProvider
                              name="confirmar contraseña"
                              rules="required"
                              vid="confirmation"
                              v-slot="{ errors }"
                            >
                              <v-text-field
                                filled
                                rounded
                                class="rounded-small"
                                required
                                label="Confirmar contraseña"
                                name="password"
                                :append-icon="
                                  showConfirmPassword
                                    ? 'mdi-eye-outline'
                                    : 'mdi-eye-off-outline'
                                "
                                :type="
                                  showConfirmPassword ? 'text' : 'password'
                                "
                                v-model="confirm_password"
                                :error-messages="errors"
                                @click:append="
                                  showConfirmPassword = !showConfirmPassword
                                "
                              ></v-text-field>
                            </ValidationProvider>
                          </v-col>

                          <v-col cols="12" lg="4">
                            <v-btn
                              :disabled="
                                [
                                  old_password,
                                  password,
                                  confirm_password
                                ].includes('')
                              "
                              large
                              block
                              class="rounded-small"
                              color="success shadow-4"
                              @click="passes(UpdatePassword)"
                              >Actualizar</v-btn
                            >
                          </v-col>
                        </v-row>
                      </ValidationObserver>
                    </v-card-text>
                  </v-tab-item>
                </v-tabs>
                <br />
              </v-card>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" lg="5" v-if="User.role_id === 1">
          <v-card outlined>
            <v-card-title class="subtitle-1 font-weight-bold secondary--text">
              Servidores
              <v-spacer></v-spacer>
              <v-icon color="grey lighten-1">mdi-cloud</v-icon>
            </v-card-title>

            <v-card-text>
              <v-text-field
                filled
                rounded
                class="rounded-small"
                v-model="search"
                append-icon="mdi-magnify"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>

              <v-data-iterator
                :headers="headers"
                :items="Clients"
                :search="search"
                :items-per-page="itemsPerPage"
                sort-by="name"
                hide-default-footer
                :page.sync="page"
                @page-count="pageCount = $event"
              >
                <template v-slot:default="props">
                  <div v-for="(item, index) in props.items" :key="index">
                    <v-hover v-slot:default="{ hover }">
                      <v-list-item
                        v-on="on"
                        @click="selectClient(item.id)"
                        two-line
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.name }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.ip }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action
                          class="my-auto"
                          v-if="User.client_id === item.id"
                        >
                          <v-icon color="success"
                            >mdi-checkbox-marked-circle</v-icon
                          >
                        </v-list-item-action>

                        <v-list-item-action class="my-auto" v-else>
                          <v-icon v-if="hover" color="grey lighten-1"
                            >mdi-checkbox-marked-circle</v-icon
                          >
                        </v-list-item-action>
                      </v-list-item>
                    </v-hover>
                  </div>
                </template>
              </v-data-iterator>

              <v-row justify="center">
                <v-col cols="auto">
                  <v-pagination
                    circle
                    v-model="page"
                    color="primary"
                    total-visible="5"
                    :length="pageCount"
                  ></v-pagination>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!-- Modal carga de foto -->
    <UploadAvatarComponent
      :activeDialog="photoDialog"
      type="user"
      :id="userdata.id"
      @dialog:change="closeUploadAvatarDialog"
    ></UploadAvatarComponent>
    <!-- Fin Modal carga de foto -->

    <v-dialog v-model="dialog" hide-overlay persistent width="350">
      <v-card color="primary">
        <v-card-text class="mb-1 pt-1">
          <span class="white--text ">Cambiando servidor, por favor espere</span>
          <v-progress-linear indeterminate color="white"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import UploadAvatarComponent from "@/components/Upload/UploadAvatarComponent";

export default {
  components: {
    UploadAvatarComponent
  },

  data() {
    return {
      //Upload Avatar dialog
      photoDialog: false,
      //Paginación
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      //Data actual
      olduserdata: {
        name: "",
        email: ""
      },
      //Data auxiliar para actualizar
      userdata: {
        name: "",
        email: ""
      },
      old_password: "",
      password: "",
      confirm_password: "",
      showOldPassword: false,
      showPassword: false,
      showConfirmPassword: false,
      headers: [
        {
          text: "Base de datos",
          value: "name",

          align: "left",
          sortable: false
        },
        {
          text: "Dirección IP",
          value: "ip",

          align: "right",
          sortable: false
        }
      ],
      search: "",

      dialog: false
    };
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile;
    },

    Clients() {
      return this.$store.getters["clients/GET_ALL_CLIENTS"];
    },
    User() {
      return this.$store.getters["passport/CURRENT_USER"];
    },
    oldDataComparison() {
      if (
        this.olduserdata.name != this.userdata.name ||
        this.olduserdata.email != this.userdata.email
      ) {
        return false;
      } else {
        return true;
      }
    }
  },

  async created() {
    try {
      const response = await this.$store.dispatch("clients/GET_ACTIVE_CLIENTS");
    } catch (error) {
      console.error(error);
    }
  },

  mounted() {
    let data = this.$store.getters["passport/CURRENT_USER"];
    this.olduserdata = JSON.parse(JSON.stringify(data));
    this.userdata = JSON.parse(JSON.stringify(data));

    if (!this.userdata.id) this.GetProfileInfo();
  },

  methods: {
    userRol() {
      let rol;

      switch (this.User.role_id) {
        case 1:
          rol = "Superusuario";
          break;

        case 2:
          rol = "Supervisor";
          break;

        case 3:
          rol = "Agente";
          break;

        default:
          break;
      }

      return rol;
    },

    openUploadAvatarDialog() {
      this.photoDialog = true;
    },

    closeUploadAvatarDialog(res) {
      this.photoDialog = false;
      if (res == "success") location.reload();
    },

    async GetProfileInfo() {
      try {
        let data = await this.$store.dispatch("passport/ACTIVE_USER");
        this.olduserdata = JSON.parse(JSON.stringify(data.data.data));
        this.userdata = JSON.parse(JSON.stringify(data.data.data));
      } catch (error) {
        console.log(error);
      }
    },

    async UpdateData() {
      try {
        const enviar = {
          name: this.userdata.name !== null ? this.userdata.name : false,
          email: this.userdata.email
        };

        let info = {
          value: {
            ...enviar
          },
          id: this.userdata.id
        };

        await this.$store.dispatch("passport/UPDATE_USER", info);
        this.$snotify.success("Tus datos han sido actualizado.", "¡Genial!");
        let newData = this.$store.getters["passport/CURRENT_USER"];
        this.olduserdata = JSON.parse(JSON.stringify(newData));
        this.userdata = JSON.parse(JSON.stringify(newData));
      } catch (e) {
        console.error(e.response.data.error);

        this.$snotify.error(
          "Revise los campos e intente nuevamente.",
          "¡Error!"
        );
      }
    },

    async UpdatePassword() {
      try {
        const enviar = {
          old_password: this.old_password,
          password: this.password,
          password_confirmation: this.confirm_password,
          id: this.userdata.id
        };

        let response = await this.$store.dispatch(
          "passport/UPDATE_PASSWORD",
          enviar
        );

        if (response.status == 200) {
          this.$snotify.success(
            "Contraseña cambiada. No la olvides.",
            "¡Genial!"
          );

          this.old_password = "";
          this.password = "";
          this.confirm_password = "";

          this.$nextTick(() => {
            this.$refs.passwordForm.reset();
          });
        }
      } catch (error) {
        this.$snotify.error(error.response.data.error, "Error!");
        // console.error(error);
      }
    },

    /**
     * [selectClient description]
     * Nota: Actualizar cliente asociado al usuario
     * solo para superusurios
     * @param  {number} client_id [description]
     * @return {Promise<any>}           [description]
     */
    async selectClient(client_id) {
      try {
        if (this.User.client_id !== client_id) {
          this.dialog = true;
          // console.log(client_id);
          await this.$store.dispatch("passport/UPDATE_TOKEN_CLIENT", client_id);
          this.dialog = false;

          this.$snotify.success("Cambiado de servidor realizado.", "¡Genial!");
        }
      } catch (error) {
        this.dialog = false;
        // console.error(error);

        this.$snotify.error(
          "No se pudo realizar el cambio de servidor.",
          "Error"
        );
      }
    }
  }
};
</script>

<style></style>
